import { render, staticRenderFns } from "./WorkspaceGeneNodeInspectorContent.vue?vue&type=template&id=4bc42b6a&scoped=true"
import script from "./WorkspaceGeneNodeInspectorContent.vue?vue&type=script&lang=js"
export * from "./WorkspaceGeneNodeInspectorContent.vue?vue&type=script&lang=js"
import style0 from "./WorkspaceGeneNodeInspectorContent.vue?vue&type=style&index=0&id=4bc42b6a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc42b6a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/CFDE Knowledge - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4bc42b6a')) {
      api.createRecord('4bc42b6a', component.options)
    } else {
      api.reload('4bc42b6a', component.options)
    }
    module.hot.accept("./WorkspaceGeneNodeInspectorContent.vue?vue&type=template&id=4bc42b6a&scoped=true", function () {
      api.rerender('4bc42b6a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/customComponents/revealKgWorkspace/WorkspaceGeneNodeInspectorContent.vue"
export default component.exports